export default "__VITE_ASSET__Fzg2CR$V__"